module.exports = __webpack_public_path__ + "static/media/app_store_pt.6cfe15ad.png";